const kuperShiftsCreatePays = {
    colsOrder: ['number', 'executor', 'amount'],
    cols: {
        number: { content: '№', width: 12 },
        executor: { content: 'Исполнитель', width: 64 },
        amount: { content: 'Сумма', width: 24 },
    },
    deletesCols: [],
    url: 'kuperShift',
    emptyInfo: {
        title: 'Смены не найдены',
        description: 'В данном реестре <br/>нет смен для импорта',
    },
} as const;

export default kuperShiftsCreatePays;
